import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@app/auth/auth.service';
import { RouteHistoryService } from '@app/auth/route-history.service';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const routeHistory = inject(RouteHistoryService);

  const token = authService.getToken();

  const publicRoutes = [
    '/',
    '/login',
    '/signup',
    '/reset-password',
    '/privacy-policy',
    '/terms-of-service',
  ];

  const isPublicRoute = publicRoutes.some(
    (r) => state.url === r || state.url.startsWith(r + '?')
  );

  if (!token && !isPublicRoute) {
    return router.createUrlTree(['/login']);
  }

  if (token && isPublicRoute) {
    const lastUrl = routeHistory.getLastUrl();

    if (lastUrl === state.url) {
      return router.parseUrl('/connections');
    }

    return router.parseUrl(lastUrl);
  }

  return true;
};